// extracted by mini-css-extract-plugin
export default {"badge":"MicrositeViewCountBadge_badge__prw1I"};